export default __webpack_public_path__ + "static/media/semi-circle-yellow-1.001f9169.svg";